import type {Router} from 'vue-router';

// Singleton router reference, similar to services/store.ts.
// Allows non-Vue code (e.g. InfoWindow toolbar callbacks in competitive.js)
// to call getRouter().push(...) for programmatic navigation without access
// to a component's this.$router.

let router: Router;

/**
 * Register a new router for use anywhere in the application by using getRouter().
 */
function registerRouter(newRouter: Router) {
  router = newRouter;
}

/**
 * Returns the registered router or throws an error if no router has been registered.
 */
function getRouter(): Router {
  if (!router) {
    throw new ReferenceError('No router has been registered.');
  }
  return router;
}

export {
  registerRouter,
  getRouter,
};
